<template>
    <Modal id="balance-add" :show-footer="false" :show-title="false" @cancel="cancel">
        <div class="title">Bakiye Yükleme</div>
        <div>
            <div>Aktarılacak Bakiye</div>
            <a-input class="supsis-input" v-model="price" type="number"></a-input>
        </div>
        <div class="balance-details">
            <div class="detail">
                <div class="detail-title">Mevcut Bakiye</div>
                <div>{{ formatPrice(wallet.whatsapp.amount) }}TL</div>
            </div>
            <div class="detail">
                <div class="detail-title">Alınan Bakiye</div>
                <div>{{ formatPrice(price) }}TL</div>
            </div>
            <div class="detail">
                <div class="detail-title">Toplam Bakiye</div>
                <div>{{ formatPrice(wallet.whatsapp.amount + +price) }}TL</div>
            </div>
        </div>
        <div>
            <div class="card-title">Ödeme Yapılacak Kart</div>
            <div class="current-card">
                <div class="card-information">
                    <div class="card-type-logo">
                        <DynamicSvg :name="formatedType()" />
                    </div>
                    <div class="card-detail">
                        <div class="card-bin-number">{{ formatedNumber() }}</div>
                        <div class="card-type">{{ billingDetail.cardAssociation }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="balance-footer">
            <div class="supsis-modal-button" @click="cancel">İptal</div>
            <div class="supsis-modal-button second" @click="submit">Kaydet</div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../components/common/Modal2.vue";
import DynamicSvg from "../../../../components/DynamicSvg.vue";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "WalletAddBalance",
    components: {
        Modal,
        DynamicSvg,
    },
    data: () => ({
        price: 0,
    }),
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
            wallet: (state) => state.wallet.wallet,
        }),
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        formatPrice(price) {
            return (+price).toFixed(4);
        },
        formatedType() {
            return this.billingDetail.cardAssociation[0] + this.billingDetail.cardAssociation.slice(1).toLowerCase();
        },
        submit() {
            this.$emit("add-balance", +this.price);
        },
        formatedNumber() {
            const firstFour = this.billingDetail.binNumber.slice(0, 4);
            const lastFour = this.billingDetail.binNumber.slice(4, 8);
            return `${firstFour} ${lastFour} **** ****`;
        },
    },
};
</script>
<style lang="scss">
#balance-add {
    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: bold;
    }
    .card-title {
        font-size: 16px;
        margin-top: 20px;
        font-weight: bold;
    }
    .current-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 14px;
        .card-information {
            display: flex;
            align-items: center;
            gap: 5px;
            .card-type-logo {
                svg {
                    width: 50px;
                    height: 50px;
                }
            }
            .card-detail {
                .card-bin-number {
                    font-size: 16px;
                    font-weight: bold;
                }
                .card-type {
                    font-size: 12px;
                }
            }
        }
    }

    .balance-details {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        .detail {
            background: #ffa800;
            border-radius: 200px;
            padding: 10px 15px;
            flex-grow: 1;
            flex-basis: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            line-height: 12px;
            color: white;
            .detail-title {
                font-weight: bold;
                text-transform: uppercase;
            }
        }
    }
    .supsis-input {
        border-radius: 20px;
        height: auto;
        padding: 10px 20px;
        outline: none !important;
        border: none !important;
    }
    .balance-footer {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 4px;
        margin-top: 10px;
    }

    .supsis-modal-button {
        background: #ffffff00;
        border: 1px solid #bbbbbb;
        border-radius: 100px;
        padding: 5px 30px;
        cursor: pointer;
        user-select: none;

        &.second {
            background: #ffa800;
            color: white;
            border: none;
        }
    }
}
</style>
